import { FrequencyGraphic } from './FrequencyGraphic';
import { Settings } from '/js/Settings';

// Line format from rf_sim_ws.py: "[110.000 MHz] RSSI:-20.50 Noise:-39.90 SNR:19.40 true"
const LINE_REGEX = /\[([\d.]+) MHz\] RSSI:([-\d.]+) Noise:([-\d.]+) SNR:([-\d.]+) (\w+)/;

class FrequenciesGraphicManager
{
  constructor(container_element)

  {
    this.container_element = container_element;
    this.ws = null;
    this.ws_url = Settings.rf_sim_ws_url;
    this.frequencies_by_mhz = {};
    // this.container_element = document.querySelector('.pharos__frequencies-graphic');
    this.bar_container_element = this.container_element.querySelector('.pharos__frequencies-graphic');

    this.pharos_element = document.querySelector('.pharos');
  }

  parse_line(line)
  {
    const match = String(line).match(LINE_REGEX);
    if (!match)
    {
      return null;
    }
    return {
      freq_mhz: parseFloat(match[1]),
      rssi: parseFloat(match[2]),
      noise: parseFloat(match[3]),
      snr: parseFloat(match[4]),
      state: match[5]
    };
  }

  start(url = this.ws_url)
  {
    if (this.ws && this.ws.readyState === WebSocket.OPEN)
    {
      return;
    }

    this.ws_url = url || Settings.rf_sim_ws_url;
    this.ws = new WebSocket(this.ws_url);

    this.ws.onopen = () =>
    {
      console.log('[FrequenciesGraphicManager] Connected to', this.ws_url);
    };

    this.ws.onmessage = (event) =>
    {
      const line = event.data;
      const data = this.parse_line(line);
      if (!data)
      {
        return;
      }
      this.on_frequency_data_update(data);
    };

    this.ws.onerror = (e) =>
    {
      console.error('[FrequenciesGraphicManager] WebSocket error', e);
    };

    this.ws.onclose = () =>
    {
      console.log('[FrequenciesGraphicManager] Disconnected from', this.ws_url);
      this.ws = null;
    };
  }

  stop()
  {
    if (this.ws)
    {
      this.ws.close();
      this.ws = null;
    }
  }

  is_connected()
  {
    return this.ws != null && this.ws.readyState === WebSocket.OPEN;
  }

  get_frequency_data(freq_mhz)
  {
    return this.frequencies_by_mhz[freq_mhz];
  }

  get_all_frequencies()
  {
    return this.frequencies_by_mhz;
  }

  on_frequency_data_update(data)
  {
    if (!this.frequencies_by_mhz[data.freq_mhz])
    {
      this.frequencies_by_mhz[data.freq_mhz] = new FrequencyGraphic(this.bar_container_element, data);
      this.frequencies_by_mhz[data.freq_mhz].start();
    }

    this.frequencies_by_mhz[data.freq_mhz].update(data);
  }
}

export { FrequenciesGraphicManager };
